<template>
  <div>
    <div
      v-if="isSeoServiceConnected"
      class="row display-flex-sm"
    >
      <div class="col-sm-12 col-md-6 col-lg-4">
        <c-box
          :loading="updates.fetching"
          title="Апдейты поисковых систем"
          class="h-100pc-sm mb-0-sm"
        >
          <div class="row updates">
            <up-info
              :update="getUpdate('y')"
              :img="require('../../img/yandex.png')"
              padding-right="7px"
              img-alt="Yandex"
            />
            <up-info
              :update="getUpdate('g')"
              :img="require('../../img/google.png')"
              padding-left="7px"
              img-alt="Google"
            />
          </div>
        </c-box>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-4">
        <c-box
          title="On-line служба качества"
          header-background-variant="warning"
          collapsable
          class="h-100pc-sm mb-0-sm"
        >
          <div class="row">
            <div
              class="col-sm-4 quality-service-btn"
              data-toggle="modal"
              :data-target="`#${$getConst('FORM_QUALITY_SERVICE_MODAL_ID')}`"
              @click="setQualityServiceSelectedType('thanks')"
            >
              <div class="quality-service-img-container">
                <span class="quality-service-helper" />
                <img
                  src="../../img/handshake.png"
                  alt="Поблагодарить"
                  class="quality-service-img"
                >
              </div>
              Поблагодарить
            </div>
            <div
              class="col-sm-4 quality-service-btn"
              data-toggle="modal"
              :data-target="`#${$getConst('FORM_QUALITY_SERVICE_MODAL_ID')}`"
              @click="setQualityServiceSelectedType('complain')"
            >
              <div class="quality-service-img-container">
                <span class="quality-service-helper" />
                <img
                  src="../../img/dislike.png"
                  alt="Пожаловаться"
                  class="quality-service-img"
                >
              </div>
              Пожаловаться
            </div>
            <div
              class="col-sm-4 quality-service-btn"
              data-toggle="modal"
              :data-target="`#${$getConst('FORM_QUALITY_SERVICE_MODAL_ID')}`"
              @click="setQualityServiceSelectedType('advice')"
            >
              <div class="quality-service-img-container">
                <span class="quality-service-helper" />
                <img
                  src="../../img/comment.png"
                  alt="Посоветовать"
                  class="quality-service-img"
                >
              </div>
              Посоветовать
            </div>
          </div>
          <div class="text-center text-muted quality-service-text">
            Мы всегда рады конструктивной критике.
          </div>
        </c-box>
      </div>
    </div>

    <template v-if="isSeoServiceConnected">
      <h2>Продвижение сайтов</h2>

      <div class="row">
        <div class="col-md-12">
          <c-box
            title="Динамика позиций за текущий месяц"
            class="priority-positions"
            shadow
            :loading="projectPriorityPositionsFetching"
          >
            <form class="form-inline margin-bottom">
              <client-projects-core-select />
              <client-projects-region-select form-group-margin-bottom />
              <query-search
                v-if="projectPriorityPositionsQueries.length"
                v-model="querySearch"
              />
              <sengine-select
                v-if="sengineSelectable"
                v-model="sengine"
                :yandex-disabled="!isPromoteBySengine($getConst('SENGINE_YANDEX'))"
                :google-disabled="!isPromoteBySengine($getConst('SENGINE_GOOGLE'))"
                small
                margin-bottom="15px"
              />
            </form>

            <div class="margin-bottom">
              <table
                v-if="projectPriorityPositionsQueries.length"
                class="table"
              >
                <thead>
                  <tr>
                    <th>
                      Запрос
                    </th>
                    <th v-if="isSengineLogoVisible($getConst('SENGINE_YANDEX'))">
                      <img
                        src="../../img/yandex.png"
                        alt="Yandex"
                      >
                    </th>
                    <th
                      v-for="date in getVisibleNotEmptyUpdatesDates($getConst('SENGINE_YANDEX'))"
                      :key="date + 'y_col'"
                      :class="{ 'update-highlighted': isUpdateHighlighted($getConst('SENGINE_YANDEX'), date) }"
                    >
                      {{ date | moment('DD.MM') }}
                    </th>
                    <th v-if="isSengineLogoVisible($getConst('SENGINE_GOOGLE'))">
                      <img
                        src="../../img/google.png"
                        alt="Google"
                      >
                    </th>
                    <th
                      v-for="date in getVisibleNotEmptyUpdatesDates($getConst('SENGINE_GOOGLE'))"
                      :key="date + 'g_col'"
                      :class="{ 'update-highlighted': isUpdateHighlighted($getConst('SENGINE_GOOGLE'), date) }"
                    >
                      {{ date | moment('DD.MM') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="query in projectPriorityPositionsQueries"
                    v-show="query.txt.includes(querySearch)"
                    :key="query.txt"
                  >
                    <td>{{ query.txt }}</td>
                    <td v-if="isSengineLogoVisible($getConst('SENGINE_YANDEX'))" />
                    <td
                      v-for="date in getVisibleNotEmptyUpdatesDates($getConst('SENGINE_YANDEX'))"
                      :key="query.txt + date + 'y'"
                      :class="{ 'update-highlighted': isUpdateHighlighted($getConst('SENGINE_YANDEX'), date) }"
                    >
                      {{ getQueryPosition(query, date, 'y') }} <sub v-if="!empty(getQueryPosition(query, getNotEmptyUpdatesDates('y')[getNotEmptyUpdatesDates('y').indexOf(date) - 1], 'y')) && !empty(getQueryPosition(query, date, 'y'))">
                        <positions-diff :value="getQueryPositionsDiff(query, getNotEmptyUpdatesDates('y')[getNotEmptyUpdatesDates('y').indexOf(date) - 1], date, 'y')" />
                      </sub>
                    </td>
                    <td v-if="isSengineLogoVisible($getConst('SENGINE_GOOGLE'))" />
                    <td
                      v-for="date in getVisibleNotEmptyUpdatesDates($getConst('SENGINE_GOOGLE'))"
                      :key="query.txt + date + 'g'"
                      :class="{ 'update-highlighted': isUpdateHighlighted($getConst('SENGINE_GOOGLE'), date) }"
                    >
                      {{ getQueryPosition(query, date, 'g') }} <sub v-if="!empty(getQueryPosition(query, getNotEmptyUpdatesDates('g')[getNotEmptyUpdatesDates('g').indexOf(date) - 1], 'g')) && !empty(getQueryPosition(query, date, 'g'))">
                        <positions-diff :value="getQueryPositionsDiff(query, getNotEmptyUpdatesDates('g')[getNotEmptyUpdatesDates('g').indexOf(date) - 1], date, 'g')" />
                      </sub>
                    </td>
                  </tr>
                </tbody>
              </table>
              <no-data v-else />
            </div>

            <div class="more-container">
              <router-link
                tag="button"
                class="btn btn-default positions-btn"
                style="margin-right: 10px;"
                :to="{ name: 'Positions' }"
              >
                Смотреть динамику всех позиций
              </router-link>

              <router-link
                tag="button"
                class="btn background-white border-danger text-danger"
                :to="{ name: 'MonthlyReport' }"
              >
                Смотреть отчет по услуге
              </router-link>
            </div>
          </c-box>
        </div>
      </div>
    </template>

    <template v-if="isSeoServiceConnected">
      <h2>Рекомендованные услуги</h2>

      <services-not-connected />
    </template>

    <h2>Новости</h2>

    <div class="overlay-wrapper">
      <div class="row">
        <carousel
          :per-page="6"
          :per-page-custom="[[320, 1], [768, 3], [1024, 6]]"
          :navigation-enabled="true"
          :navigation-click-target-size="0"
          :pagination-enabled="false"
          :scroll-per-page="false"
        >
          <slide
            v-for="item in publicationsSorted"
            :key="item.id"
          >
            <div style="padding: 15px; height: 100%">
              <publication-preview
                :data="item"
                :date="false"
                :description-limit="100"
                detail-route-name="NewsDetail"
                style="height: 100%"
              />
            </div>
          </slide>
        </carousel>
      </div>
      <c-loading-overlay v-if="publications.fetching" />
    </div>
    <div
      v-if="publicationsNotEmpty"
      class="row text-center"
    >
      <router-link
        tag="button"
        class="btn-lg background-white border-danger text-danger"
        :to="{name: 'News'}"
      >
        Все новости
      </router-link>
    </div>
  </div>
</template>

<script>
import CBox from '../components/ui/CBox'
import UpInfo from '../components/views/home/UpInfo'
import PositionsDiff from '../components/views/home/PositionsDiff'
import PublicationPreview from '../components/PublicationPreview'
import ClientProjectsRegionSelect from '../../../Modules/Seo/Resources/assets/js/components/ClientProjectsRegionSelect'
import ClientProjectsCoreSelect from '../../../Modules/Seo/Resources/assets/js/components/ClientProjectsCoreSelect.vue'
import QuerySearch from '../../../Modules/Seo/Resources/assets/js/components/QuerySearch'
import NoData from '../components/NoData'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import { Carousel, Slide } from 'vue-carousel'
import helper from '../mixins/helper'
import { handleClientProjectsSelectedRegionChange } from '../helper'
import ServicesNotConnected from '../components/ServicesNotConnected'
import SengineSelect from '../../../Modules/Seo/Resources/assets/js/components/SengineSelect'
import grid from '../mixins/grid'
import constants from '../constants'
import CLoadingOverlay from '../components/ui/CLoadingOverlay'
import publications from '../mixins/publications'
import apiService from '../../../Modules/Seo/Resources/assets/js/apiService'
import Notification from '../notification'

export default {
  name: 'Home',
  components: {
    CLoadingOverlay,
    SengineSelect,
    ServicesNotConnected,
    CBox,
    UpInfo,
    PositionsDiff,
    PublicationPreview,
    Carousel,
    Slide,
    ClientProjectsRegionSelect,
    ClientProjectsCoreSelect,
    QuerySearch,
    NoData
  },
  mixins: [helper, grid, publications],
  data: () => {
    return {
      querySearch: '',
      sengine: constants.SENGINE_YANDEX,
      updates: {
        fetching: true,
        data: []
      }
    }
  },
  computed: {
    sengineSelectable () {
      return !this.gridLg
    },
    onlyLatestUpdateVisible () {
      return this.gridXs
    },
    onlyEdgeUpdatesVisible () {
      return this.sengineSelectable && !this.onlyLatestUpdateVisible
    },
    isSeoServiceConnected () {
      return this.isServiceConnected(this.$getConst('SERVICE_SEO'))
    },
    ...mapGetters({
      getNotEmptyUpdatesDates: 'seo/project/priorityPositions/getNotEmptyUpdatesDates',
      getQueryPosition: 'seo/project/priorityPositions/getQueryPosition',
      getQueryPositionsDiff: 'seo/project/priorityPositions/getQueryPositionsDiff',
      clientProjectsSelectedProject: 'seo/client/projects/getSelectedProject',
      isPromoteBySengine: 'seo/client/projects/isSelectedProjectPromoteBySengine',
      isServiceConnected: 'services/isConnected'
    }),
    ...mapState({
      selectedProjectId: state => state.seo.client.projects.selectedProjectId,
      projectPriorityPositionsFetching: state => state.seo.project.priorityPositions.fetching,
      projectPriorityPositionsQueries: state => state.seo.project.priorityPositions.queries
    })
  },
  mounted () {
    if (this.selectedProjectId) {
      this.init()
    }

    this.$root.$on('clientProjectsSelectedProjectIdChange', this.init)
    this.$root.$on('clientProjectsSelectedRegionChange', handleClientProjectsSelectedRegionChange)
    this.$root.$on('servicesLoaded', this.handleServicesLoaded)

    this.handleServicesLoaded()

    this.fetchPublications('news', 1, 6)
  },
  destroyed () {
    this.$root.$off('clientProjectsSelectedRegionChange', handleClientProjectsSelectedRegionChange)
    this.$root.$off('clientProjectsSelectedProjectIdChange', this.init)
    this.$root.$off('servicesLoaded', this.handleServicesLoaded)
  },
  methods: {
    init () {
      this.setClientProjectsSelectedRegion(this.clientProjectsSelectedProject.region)

      // Обновляем выбранную ПС, если в выбранном проекте нет ПС, которая в данный момент выбрана
      if (
        this.clientProjectsSelectedProject.sengines.length &&
        !this.clientProjectsSelectedProject.sengines.includes(this.sengine)
      ) {
        this.sengine = this.clientProjectsSelectedProject.sengines[0]
      }

      this.fetchProjectPriorityPositions({
        idParent: this.selectedProjectId,
        withPriority: 1
      })
    },
    isSengineLogoVisible (sengine) {
      if (!this.isPromoteBySengine(sengine)) {
        return false
      }

      if (!this.sengineSelectable) {
        return true
      }

      if (this.sengine !== sengine) {
        return false
      }

      return this.onlyEdgeUpdatesVisible
    },
    isUpdateHighlighted (sengine, date) {
      if (this.onlyLatestUpdateVisible) {
        return undefined
      }

      const notEmptyUpdatesDates = this.getNotEmptyUpdatesDates(sengine)

      return notEmptyUpdatesDates.indexOf(date) === notEmptyUpdatesDates.length - 1
    },
    getVisibleNotEmptyUpdatesDates (sengine) {
      const notEmptyUpdatesDates = this.getNotEmptyUpdatesDates(sengine)

      if (!this.sengineSelectable) {
        return notEmptyUpdatesDates
      }

      if (sengine !== this.sengine) {
        return []
      }

      if (this.onlyEdgeUpdatesVisible && notEmptyUpdatesDates.length > 2) {
        return [notEmptyUpdatesDates[0], notEmptyUpdatesDates[notEmptyUpdatesDates.length - 1]]
      }

      if (this.onlyLatestUpdateVisible && notEmptyUpdatesDates.length > 1) {
        return [notEmptyUpdatesDates[notEmptyUpdatesDates.length - 1]]
      }

      return notEmptyUpdatesDates
    },
    fetchUpdatesCurrent () {
      this.updates.fetching = true

      apiService.getUpdatesCurrent()
        .then(response => {
          this.updates.data = response.data.updates

          this.updates.fetching = false
        })
        .catch(() => {
          this.updates.fetching = false

          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить информацию по текущим апдейтам.'
          })
        })
    },
    getUpdate (type) {
      return this.updates.data.find((update) => update.type === type) || {}
    },
    handleServicesLoaded () {
      if (this.isSeoServiceConnected) {
        this.fetchUpdatesCurrent()
      }
    },
    ...mapActions({
      fetchProjectPriorityPositions: 'seo/project/priorityPositions/fetch'
    }),
    ...mapMutations({
      setQualityServiceSelectedType: 'seo/forms/qualityService/setSelectedType',
      setClientProjectsSelectedRegion: 'seo/client/projects/setSelectedRegion'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.quality-service-btn {
  font-weight: bold;
  text-align: center;
  cursor: pointer;

  @media (max-width: $xsBreakpoint) {
    text-align: left;
    margin-bottom: 15px;

    &:after {
      display: table;
      content: '';
      clear: both;
    }
  }

  .quality-service-img-container {
    height: 50px;

    @media (max-width: $xsBreakpoint) {
      float: left;
      width: 40px;
      height: initial;
    }

    .quality-service-helper {
      display: inline-block;
      height: 100%;
      vertical-align: middle;

      @media (max-width: $xsBreakpoint) {
        display: none;
      }
    }
  }
}

.quality-service-text {
  margin-top: 13px;

  @media (max-width: $xsBreakpoint) {
    margin-top: 0px;
  }
}

.updates {
  display: flex;
}

.more-container {
  @media (max-width: $xsBreakpoint) {
    .btn {
      width: 100%;
    }

    .positions-btn {
      margin-bottom: 15px;
    }
  }
}

.update-highlighted {
  background-color: #f3f4f8;
}

.display-flex-sm {
  @media (min-width: $smBreakpoint) {
    display: flex;
  }
}

.h-100pc-sm {
  @media (min-width: $smBreakpoint) {
    height: 100%;
  }
}

.mb-0-sm {
  @media (min-width: $smBreakpoint) {
    margin-bottom: 0;
  }
}

.overlay-wrapper {
  margin-bottom: 15px;
  @media (max-width: $xsBreakpoint) {
    margin-bottom: 0;
  }
}
</style>
